import PropTracker from "../../../prop-trackers/prop-tracker.js";
import PropChainTracker from "../../../prop-tracker-utils/prop-chain-tracker.js";
import DictTrackerObjGen from "../../../prop-tracker-utils/dict-tracker-obj-gen.js";
import { Combiner } from "../../../prop-tracker-utils/combiner.js";

import ShallowObjectMerger from "../../../utils/shallow-object-merger.js";

import { MaterialTypes_T } from "../../data-defs/material-types.js";
import { getMaterialFullTypeKey as getKey } from "../../data-defs/material-full-types.js";

import MaterialTrackerLoader from "./materials/material-tracker-loader.js";

const pbrBasicKey = getKey({ type: MaterialTypes_T.PBR, materialType: "basic" });
const pbrRegularKey = getKey({ type: MaterialTypes_T.PBR, materialType: "pbr" });

const Types = [pbrBasicKey, pbrRegularKey];

class MaterialLoading {
    constructor(evtCtx, shlWrapCtx, shlEvtCtx, materialLoaders) {
        this._matDataTrackers = {};

        for (const type of Types) {
            this._matDataTrackers[type] = new PropChainTracker(evtCtx);
        }

        const matTrackLoaders = {
            [pbrBasicKey]: new MaterialTrackerLoader(this._matDataTrackers[pbrBasicKey], materialLoaders[pbrBasicKey], pbrBasicKey),
            [pbrRegularKey]: new MaterialTrackerLoader(this._matDataTrackers[pbrRegularKey], materialLoaders[pbrRegularKey], pbrRegularKey),
        };

        const matGenByType = {};
        const merger = new Combiner((key) => new ShallowObjectMerger());

        for (const [i, type] of Types.entries()) {
            const matGen = new DictTrackerObjGen(shlWrapCtx, shlEvtCtx, matTrackLoaders[type]);
            matGenByType[type] = matGen;

            const mergeSource = new PropTracker();
            merger.setSource(i, mergeSource);
            mergeSource.track(matGen.data, matGen.events);
        }

        const mergeGen = new DictTrackerObjGen(shlWrapCtx, shlEvtCtx, merger);

        this._materials = Object.freeze({
            byType: matGenByType,
            all: mergeGen,
        });
    }

    get materials() { return this._materials; }

    track(materialDataByType) {
        if (materialDataByType) {
            for (const type of Types) {
                this._matDataTrackers[type].track(materialDataByType[type].data, ["value"]);
            }
        } else {
            for (const type of Types) {
                this._matDataTrackers[type].track();
            }
        }
    }

    update() {
        for (const type of Types) {
            this._materials.byType[type].update();
        }

        this._materials.all.update();
    }
}

export default MaterialLoading;
